import React from 'react';

interface Props {
    props?: any;
}

export const Dashboard = ({ ...props }: Props) => {
    return <div>I am your Dashboard!</div>;
};
